import React from "react";

const Loading = <P extends object>(props: P & { message?: string }): JSX.Element => (
    <React.Fragment>
        <span className="loading">{ props.message ? props.message : "Loading..."}</span>
    </React.Fragment>);

export default Loading;
